import React, { FC, JSX } from 'react';
import { Skeleton } from 'src/common';
import { useTenderPreview } from 'src/models/procurements/Preview/hooks';
import { usePreviewTabState } from 'src/models/procurements/hooks';
import { ActivePreviewTab } from 'src/models/procurements/types';
import TenderPreviewHeader from './Header';
import TenderPreviewNav from './Nav';
import TenderPreviewInfo from './Info';
import TenderPreviewComments from './Comments';
import previewStyles from 'src/shared/InfoSidebar/index.module.scss';
import TenderPreviewMatches from './Matches';
import { TenderPreviewProvider } from 'src/models/procurements/Preview/providers';
import { FeatureFlag, useFeatureFlag } from 'src/helpers';
import { TenderPreviewOutcome } from './Outcome';

interface IProps {
  tenderId: string;
}

function TenderPreviewLoading({ children }: { children: React.ReactNode }): JSX.Element {
  const data = useTenderPreview();
  return data.loading ? <Skeleton loading active /> : <>{children}</>;
}

export const TenderPreview: FC<IProps> = ({ tenderId }) => {
  const [activeTab] = usePreviewTabState();
  const isShowOnlyAwardedFeature = useFeatureFlag(FeatureFlag.ShowOnlyAwarded);

  return (
    <TenderPreviewProvider id={tenderId}>
      <div className={previewStyles.header}>
        <TenderPreviewLoading>
          <TenderPreviewHeader />
          <TenderPreviewNav />
        </TenderPreviewLoading>
      </div>
      <div className={previewStyles.content}>
        <TenderPreviewLoading>
          {activeTab === ActivePreviewTab.Info && <TenderPreviewInfo />}
          {activeTab === ActivePreviewTab.Comments && <TenderPreviewComments />}
          {activeTab === ActivePreviewTab.Matches && <TenderPreviewMatches />}
          {isShowOnlyAwardedFeature && activeTab === ActivePreviewTab.Outcome && (
            <TenderPreviewOutcome tenderId={tenderId} />
          )}
        </TenderPreviewLoading>
      </div>
    </TenderPreviewProvider>
  );
};

export default TenderPreview;
